import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.loading');
import { OnInit, AfterViewChecked, OnDestroy, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-loading',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.loading/view.scss */
:host {
  display: contents;
}

.gsdc-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(32, 51, 79, 0.2);
  backdrop-filter: blur(4px);
  overscroll-behavior: contain;
  touch-action: none;
}

.gsdc-loading-overlay.is-covered {
  visibility: hidden;
  pointer-events: none;
}

.gsdc-loading-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 232px;
  max-width: 100%;
  min-height: 218px;
  padding: 30px 24px 26px;
  border: 0;
  background: transparent;
  box-shadow: none;
  outline: none;
}

.gsdc-loading-mark {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 104px;
}

.gsdc-loading-mark img {
  width: 68px;
  height: auto;
}

.gsdc-loading-track {
  position: absolute;
  inset: 0;
  border: 2px solid #e8eff8;
  border-radius: 50%;
}

.gsdc-loading-orbit {
  position: absolute;
  inset: 0;
  border: 2px solid transparent;
  border-top-color: #238bc3;
  border-right-color: #344a98;
  border-radius: 50%;
  animation: gsdc-loading-spin 1.1s linear infinite;
}

.gsdc-loading-orbit::after {
  content: "";
  position: absolute;
  top: 12px;
  right: 11px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2a74b2;
  box-shadow: 0 0 0 4px rgba(42, 116, 178, 0.062745098);
}

.gsdc-loading-label {
  margin: 23px 0 0;
  color: #526682;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  text-align: center;
  overflow-wrap: anywhere;
}

:host-context(.dark) .gsdc-loading-overlay {
  background: rgba(4, 12, 24, 0.45);
}
:host-context(.dark) .gsdc-loading-track {
  border-color: #2a3b53;
}
:host-context(.dark) .gsdc-loading-label {
  color: #b6c8e1;
}
:host-context(.dark) .gsdc-loading-orbit {
  border-top-color: #53b1de;
  border-right-color: #7c94dd;
}

@keyframes gsdc-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .gsdc-loading-orbit {
    animation: none;
  }
}`],
})
export class PortalSeasonLoadingComponent implements OnInit, AfterViewChecked, OnDestroy {
    @ViewChild('loadingStatus') loadingStatus: ElementRef<HTMLElement>;
    private returnFocus: HTMLElement = null;
    private focused = false;

    constructor(@Inject( Service) public service: Service) { }

    public ngOnInit() { this.returnFocus = document.activeElement as HTMLElement; }

    public ngAfterViewChecked() {
        if (this.service.alert?.isshow) { this.focused = false; return; }
        if (!this.focused && this.loadingStatus) {
            this.focused = true;
            this.loadingStatus.nativeElement.focus({ preventScroll: true });
        }
    }

    public ngOnDestroy() {
        if (!this.service.alert?.isshow && this.returnFocus?.isConnected) {
            this.returnFocus.focus({ preventScroll: true });
        }
    }

    @HostListener('document:keydown', ['$event'])
    public onKeydown(event: KeyboardEvent) {
        if (!this.service.alert?.isshow && event.key === 'Tab') {
            event.preventDefault();
            this.loadingStatus?.nativeElement.focus({ preventScroll: true });
        }
    }

    @HostListener('document:focusin', ['$event'])
    public onFocusIn(event: FocusEvent) {
        const status = this.loadingStatus?.nativeElement;
        if (!this.service.alert?.isshow && status && !status.contains(event.target as Node)) {
            status.focus({ preventScroll: true });
        }
    }
}

export default PortalSeasonLoadingComponent;